export default [
  {
    label: '输入框',
    value: 'input'
  }, 
  {
    label: '选择框',
    value: 'select'
  }, 
  {
    label: '密码框',
    value: 'password'
  }, 
  {
    label: '数字框',
    value: 'number'
  }, 
  {
    label: '上传框',
    value: 'upload'
  }, 
  {
    label: '颜色选择器',
    value: 'color'
  }, 
  {
    label: '地图选择器',
    value: 'map'
  }, 
  {
    label: '图标选择器',
    value: 'icon'
  }, 
  {
    label: '树型下拉框',
    value: 'tree'
  }, 
  {
    label: '单选框',
    value: 'radio'
  }, 
  {
    label: '多选',
    value: 'checkbox'
  }, 
  {
    label: '开关框',
    value: 'switch'
  }, 
  {
    label: '文本框',
    value: 'textarea'
  }, 
  {
    label: '时间框',
    value: 'time'
  }, 
  {
    label: '时间范围',
    value: 'timerange'
  }, 
  {
    label: '级联框',
    value: 'cascader'
  }, 
  {
    label: '日期框',
    value: 'date'
  }, 
  {
    label: '日期时间框',
    value: 'datetime'
  }, 
  {
    label: '日期时间范围',
    value: 'datetimerange'
  }, 
  {
    label: '多个日期',
    value: 'dates'
  }, 
  {
    label: '月',
    value: 'month'
  }, 
  {
    label: '周',
    value: 'week'
  }, 
  {
    label: '年',
    value: 'year'
  }
]